import { render, staticRenderFns } from "./RegionSelector.vue?vue&type=template&id=04b6a8d2"
import script from "./RegionSelector.vue?vue&type=script&lang=js"
export * from "./RegionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports